import { Flex, IconButton } from "@chakra-ui/react";
import { Avatar, CheckboxCheckedFilledIcon, VerifiedIcon } from "@looksrare/uikit";
import { WatchlistCollectionSearchResult } from "types/graphql";
import { Text } from "uikit";
import { useOsCollectionImages } from "views/collections/components/hooks/useOsCollectionImages";

interface CollectionResultProps {
  collection: WatchlistCollectionSearchResult;
  isSelected: boolean;
  toggleIsSelected: (collection: WatchlistCollectionSearchResult) => void;
}

export const CollectionResult = ({ collection, isSelected, toggleIsSelected }: CollectionResultProps) => {
  const osCollectionImagesQuery = useOsCollectionImages(collection.address, {
    enabled: !collection.logo,
  });

  const logoSrc = collection.logo
    ? collection.logo.src
    : (osCollectionImagesQuery.isSuccess && osCollectionImagesQuery.data.logo?.src) || undefined;

  return (
    <Flex
      key={collection.address}
      px={4}
      py={2}
      alignItems="center"
      transition="background 200ms ease"
      sx={{ _hover: { bg: "hover-ui" } }}
      minHeight={12}
      cursor="pointer"
      onClick={() => toggleIsSelected(collection)}
    >
      {isSelected ? (
        <IconButton size="xs" mr={4} colorScheme="secondary" aria-label="toggle-add-to-watchlist-modal-selection">
          <CheckboxCheckedFilledIcon />
        </IconButton>
      ) : (
        <Avatar borderRadius="4px" address={collection.address} src={logoSrc} size={32} mr={4} flexShrink={0} />
      )}
      <Flex overflow="hidden" flexDirection="column" flexGrow={2}>
        <Flex alignItems="center">
          <Text textStyle="detail" bold wordBreak="break-all">
            {collection.name}
          </Text>
          {collection.isVerified && <VerifiedIcon boxSize={4} ml={1} />}
        </Flex>
      </Flex>
    </Flex>
  );
};
